import { render } from "./CardOpsiAbsen.vue?vue&type=template&id=8710050c"
import script from "./CardOpsiAbsen.vue?vue&type=script&lang=js"
export * from "./CardOpsiAbsen.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__